import * as React from "react";
import { DynamicModuleLoader } from "redux-dynamic-modules";
import { getUserPermissionsModule } from "./userPermissionsModule";

export const UserPermissionsLoader: React.FC = ({ children }) => {
    return <DynamicModuleLoader modules={[getUserPermissionsModule()]}>{children || []}</DynamicModuleLoader>;
};
